module.exports = __webpack_public_path__ + "static/media/logo.012a2396.png";